<template>
    <div class="box">
        <div class="field">
            <p class="title">Login</p>
        </div>
        <hr style="margin-left:25px;margin-right:25px;"/>

        <table>
            <tr>
                <td>
                    <b class="textlabel">Username</b>
                </td>
                <td style="width:100%" colspan="2">
                    <input id="username" class="textfield" type="username" v-model="username"></input>
                </td>
            </tr>
            <tr>
                <td>
                    <b class="textlabel">Password</b>
                </td>
                <td  colspan="2">
                    <input id="password" class="textfield" type="password" v-model="password" @keydown.enter="login_dep()"></input>
                </td>
            </tr>
            <tr>
                <td>
                    <b class="textlabel">Remember me</b>
                </td>
                <td>
                    <input id="remember" type="checkbox" style="width:20px; float:left" v-model="remember"></input>
                </td>
                <td>
                    <button class="link" style="float:right" v-on:click="forgot_password()">Forgot Password?</button>
                </td>
            </tr>
        </table>

        <div class="field">
            <button type="button" v-on:click="login_dep()">Login</button>
            <button type="button" v-on:click="signup()">Register</button>
        </div>

        <div class="field">
            <button class="keycloak-button" type="button" v-on:click="login()"><img src="static/img/Keycloak_Logo.png"/><p>Continue with LDpa Identity</p></button>
        </div>
    </div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import { openKeycloakPopup } from '@/api'
import router from '@/router/index'
export default {
	data() {
		return {
			username: '',
            password: '',
            remember: true,
            keycloakMessageListener: null,
		}
	},
    created() {
        //this.login();
    },
	methods: {
        test(){
            api.postData({
                type:"search",
                data:{
                    pageid:1,
                }
            })
        },
        login() {
            const popup = openKeycloakPopup();

            if (!popup) {
                alert('Popup blocked, please allow popups for this site.');
                return;
            }

            if (this.keycloakMessageListener) {
                window.removeEventListener("message", this.keycloakMessageListener);
            }
            
            this.keycloakMessageListener = async function (event) {
                if (event.origin !== "https://portal.ldpa.us") return;

                if (event.data.type === "keycloak-auth-success") {
                    console.log("success")
                    const code = event.data.payload.code;
                    const codeVerifier = sessionStorage.getItem("pkce_code_verifier");
                    const redirectUri = `https://portal.ldpa.us/auth-callback`;

                    api.postData({
                        type:"login",
                        data:{
                            pageid:PAGES.LOGIN_TOKEN_PAGE,
                            auth:{
                                code:code,
                                verifier:codeVerifier,
                                redirect:redirectUri,
                            }
                        }
                    }).then((res) => {
                        var now = new Date();
                        var expire_time = now.getTime() + 14*2000*36000;
                        now.setTime(expire_time);
                        document.cookie="sessionid="+res.data.session+";expires="+now.toGMTString()+";";
                        document.cookie="user="+res.data.preferred_username+";expires="+now.toGMTString()+";";
                        document.cookie="perms="+res.data.perms+";expires="+now.toGMTString()+";";
                        document.cookie="userid="+res.data.userid+";expires="+now.toGMTString()+";";
                        document.cookie="session=;";

                        router.push('/home');
                        router.go();
                    })
                }

                if (event.data.type === "keycloak-auth-error") {
                    console.error("Login failed:", event.data.payload);
                }
            };

            window.addEventListener("message", this.keycloakMessageListener);
        },
        login_dep (){
            api.postData(
                {
                    type:"login",
                    data:{
                        pageid:PAGES.LOGIN_PAGE,
                        data:[
                            this.username,
                            this.password
                        ]
                    }
                }
            ).then((res) => {
                if(res.data.session!=null){
                    if(this.remember){
                        var now = new Date();
                        var expire_time = now.getTime() + 14*2000*36000;
                        now.setTime(expire_time);
                        document.cookie="session="+res.data.session+";expires="+now.toGMTString()+";";
                        document.cookie="user="+res.data.user+";expires="+now.toGMTString()+";";
                        document.cookie="userid="+res.data.userid+";expires="+now.toGMTString()+";";
                        document.cookie="perms="+res.data.perms+";expires="+now.toGMTString()+";";
                        document.cookie="sessionid=;";

                        var currentDate = new Date();
                        var date = currentDate.getFullYear()+"-"+('00'+(currentDate.getMonth()+1)).slice(-2)+"-"+('00'+currentDate.getDate()).slice(-2);
                        var hour = ('00'+currentDate.getHours()).slice(-2)
                        var minute = ('00'+currentDate.getMinutes()).slice(-2)
                        var seconds = ('00'+currentDate.getSeconds()).slice(-2)
                        var currentDateString = date+' '+hour+':'+minute+':'+seconds

                        document.cookie="sessionexpire="+currentDateString+";";
                    }else{
                        document.cookie="session="+res.data.session+";";
                        document.cookie="user="+res.data.user+";";
                        document.cookie="userid="+res.data.userid+";";
                        document.cookie="perms="+res.data.perms+";";
                        document.cookie="sessionexpire=Session;";
                        document.cookie="sessionid=;";
                    }
                    router.push('/home');
                    router.go();
                }else {
                    alert("Wrong password and/or username");
                }
	        });
        },
        signup() {
            router.push('/0201');
        },
        forgot_password(){
            router.push('/0203');
        }
	}
}
</script>

<style scoped>
.box{
    margin-right: 25%;
    margin-left: 25%;
    margin-top: 55px;
    border: 3px solid #35495E;
    border-radius: 20px;
}

.field{
    padding:10px;
    text-align:center;
    display: flex;
    justify-content: center;
}

.textlabel{
    white-space:nowrap;
    color:#35495E;
}

.textfield{
    width:100%;
}

.title{
    font-size:30px;
    font-weight:bold;
    color:#35495E;
    margin:25px;
}

.smalltext{
    font-size: 12px;
	color: #888888;
}

button.link {
    background:none;
    border:none;
    color:#0066dd;
    text-decoration: underline;
}

table {
    table-layout:auto;
    margin:auto;
    width:75%;
    border: none;
}
td {
    border: none;
}

.keycloak-button {
  position: relative;
  margin: 25px;
  background-color: white;
  font-size: 22px;
  font-weight: bold;
  padding: 8px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 500px; /* or set a fixed width */
  cursor: pointer;
}

.keycloak-button img {
  position: absolute;
  left: 0;
  height: 40px;
  margin-left: 20px;
}

.keycloak-button p {
  margin: 0;
  color: #35495E;
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/file/Login.vue